import { Mention } from '@tiptap/extension-mention'

// change the behaviour of the Mention extension to make a `data-mention-id`,
// rather than the `data-id` and `data-label` attributes that it would create by default.
// this keeps the behaviour the same as the pre-Vue3 version.
//
// (this is important because the backend will extract this attribute in order to
// send the mentioned person an email. See app/Models/ApplicationComment.php.)

const CommentBoxMention = Mention.extend({
    addAttributes() {
        return {
            id: {
                renderHTML({ value }) {
                    return {
                        'data-mention-id': value,
                    }
                },
            },
            label: {
                renderHTML() {
                    return {}
                },
            },
        }
    },

    renderHTML({ node, HTMLAttributes }) {
        return [
            'span',
            {
                ...HTMLAttributes,
                'data-mention-id': node.attrs.id,
                class: 'mention',
            },
            `@${node.attrs.label}`,
        ]
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-mention-id]',
                getAttrs: function(dom) {
                    const el = dom
                    return {
                        id: el.getAttribute('data-mention-id'),
                        label: el.innerText.replace(/^@/, ''),
                    }
                },
            },
        ]
    },
});

export default CommentBoxMention;
